var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentExpenses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 35.383 24.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8136",
    "data-name": "Group 8136",
    transform: "translate(-66.25 -25.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24867",
    "data-name": "Path 24867",
    d: "M101.633,32.054a6.8,6.8,0,0,0-6.8-6.8H73.054a6.8,6.8,0,0,0-6.8,6.8V42.941a6.8,6.8,0,0,0,6.8,6.8H94.828a6.8,6.8,0,0,0,6.8-6.8ZM98.911,35.23v7.712a4.082,4.082,0,0,1-4.083,4.083H73.054a4.082,4.082,0,0,1-4.083-4.083V35.23ZM91.2,42.488h3.629a1.361,1.361,0,0,0,0-2.722H91.2a1.361,1.361,0,0,0,0,2.722Zm7.712-9.98H68.972v-.454a4.082,4.082,0,0,1,4.083-4.083H94.828a4.082,4.082,0,0,1,4.083,4.083Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentExpenses);
export default __webpack_public_path__ + "static/media/PaymentExpenses.b1bea9959dd0a6f2dc93548522ba9258.svg";
export { ForwardRef as ReactComponent };